<vw-page
  [alwaysFillNav]="true"
  [page]="page"
  *ngIf="page"
  [showDealerInformation]="true"
>
  <vw-page-header>
    <div breadcrumbs>
      <vw-breadcrumbs
        [currentPage]="'terms.title' | translate"
      ></vw-breadcrumbs>
    </div>
  </vw-page-header>
  <div class="terms-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="text-center">{{ "terms.title" | translate }}</h1>
        </div>
      </div>

      <ng-container *ngIf="termSections.length">
        <div class="row" *ngFor="let ts of termSections; let i = index">
          <div class="col-12">
            <vw-toggleable
              [defaultToggled]="i === 0"
              [entireHeaderClickable]="true"
            >
              <div header>
                <span class="bold">{{
                  ts.media
                    | media: mediaCategoryTypeNames.Title : mediaTypes.Text
                }}</span>
              </div>

              <span
                [innerHTML]="
                  ts.media
                    | media: mediaCategoryTypeNames.Body : mediaTypes.HTML
                    | safe: 'html'
                "
              ></span>
            </vw-toggleable>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</vw-page>
